// ============================================================================
// csvExport — a report grid to a CSV file the browser saves
// ============================================================================
// For read-only reports whose rows are already on screen (meal forecast, unused
// package meals): no server round trip. Every field is quoted, so names with
// commas ("Menon, Rahul") and line breaks stay in their column; a BOM lets Excel
// open UTF-8 (₹, accented names) correctly.

export type CsvCell = string | number | null | undefined;

/** The CSV text: header and rows, every field quoted, CRLF line ends. */
export function toCsv(header: string[], rows: CsvCell[][]): string {
  const quote = (v: CsvCell) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  return [header, ...rows].map((r) => r.map(quote).join(',')).join('\r\n');
}

/** Saves the CSV under <paramref name="fileName"/>. */
export function downloadCsv(fileName: string, header: string[], rows: CsvCell[][]): void {
  const blob = new Blob(['﻿', toCsv(header, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
